import { TableCell, Tooltip, Typography } from '@mui/material'
import { t } from 'i18next'
import React, { useRef } from 'react'
import RecruitmentActionMenu from '../../components/Popup/RecruitmentActionMenu'
import DecisionEnum from '../../store/types/enums/DecisionEnum'
import { Row } from '../../store/types/utils/DataTableUtils'
import { formatStringDate } from '../../store/utils/dateUtils'
import useOverflowCheck from '../../store/utils/useOverflowCheck'
import { StickyCell } from '../../styles/WorklogTableStyles'

type RecruitmentRowProps = {
  candidateId: string | undefined
  recruitment: Row
  labelId: string
  handleRecruitmentRowClick: (recruitmentId: string) => void
}

export const getDecisionStyle = (decision: DecisionEnum) => {
  switch (decision) {
    case DecisionEnum.ACCEPTED:
      return { color: 'accent.green.main', fontWeight: 'bold' }
    case DecisionEnum.REJECTED:
      return { color: 'warning.main', fontWeight: 'bold' }
    case DecisionEnum.WAITING:
      return { color: 'accent.orange.main', fontWeight: 'bold' }
    default:
      return {}
  }
}

const RecruitmentRow: React.FC<RecruitmentRowProps> = ({ recruitment, labelId, handleRecruitmentRowClick }) => {
  const commentsRef = useRef<HTMLDivElement | null>(null)
  const isTextWrapped = useOverflowCheck(commentsRef)

  return (
    <>
      <TableCell onClick={() => handleRecruitmentRowClick(recruitment.id)}>{recruitment.stage}</TableCell>
      <TableCell id={labelId} onClick={() => handleRecruitmentRowClick(recruitment.id)}>
        {recruitment.step}
      </TableCell>
      <TableCell onClick={() => handleRecruitmentRowClick(recruitment.id)}>
        {recruitment.responsibles
          ?.map(
            (responsible: { firstName: string; lastName: string }) => `${responsible.firstName} ${responsible.lastName}`
          )
          .join(', ') || '-'}
      </TableCell>
      <TableCell
        sx={{
          maxWidth: 300,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        onClick={() => handleRecruitmentRowClick(recruitment.id)}
      >
        {isTextWrapped ? (
          <Tooltip placement={'bottom-start'} title={recruitment.comments}>
            <Typography ref={commentsRef} noWrap>
              {recruitment.comments ? recruitment.comments : '-'}
            </Typography>
          </Tooltip>
        ) : (
          <Typography ref={commentsRef} noWrap>
            {recruitment.comments ? recruitment.comments : '-'}
          </Typography>
        )}
      </TableCell>
      <TableCell onClick={() => handleRecruitmentRowClick(recruitment.id)} sx={getDecisionStyle(recruitment.decision)}>
        {Object.values(DecisionEnum).includes(recruitment.decision as DecisionEnum)
          ? t(`decision.${recruitment.decision.toLowerCase()}`)
          : '-'}
      </TableCell>
      <TableCell onClick={() => handleRecruitmentRowClick(recruitment.id)}>
        {formatStringDate(recruitment.completionDate, true)}
      </TableCell>
      <StickyCell
        width={40}
        align="center"
        sx={{
          right: 0,
          borderLeft: '2px solid',
          borderLeftColor: 'background.elevation8',
          '&:hover': {
            cursor: 'auto',
          },
        }}
      >
        <RecruitmentActionMenu recruitmentId={recruitment.id} />
      </StickyCell>
    </>
  )
}

export default RecruitmentRow
